import '../styles/newRequest.css';
import React, { useState, useEffect, useRef } from 'react';
import {useNavigate, useLocation } from 'react-router-dom';
import { Icon, IconButton, TextField } from '@fluentui/react';
import * as pdfjsLib from "pdfjs-dist/webpack";
import {Card, Typography, Box, Divider } from "@mui/material";
import {OpenWith} from "@mui/icons-material";
import defaultImage from '../assets/defaultimage.png'; 
import expandicon from '../assets/Icon.png'; 
import searchfile from '../assets/searchfile.png';
import clearicon from '../assets/closecircle.svg'; 
import { format } from 'date-fns';
import { useApiService } from '../services/apiServices';

const initialFormInputsValues = {
    documentId: "",
    lawyerName: "",
    courtName: "",
    courtDivisionName: "",
    appointmentDate: "",
    deponentName: "",
    isTranslatorRequired: "",
    status: ""
};

const currentDate = new Date().toISOString().split('T')[0];

const SearchRequest = () => {
    const handleApiRequest = useApiService();
    const [pdfThumbnail, setPdfThumbnail] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const [searchText, setSearchText] = useState("");
    const [filteredAffidavitRequests, setFilteredAffidavitRequests] = useState([]);
    const [formInputs, setFormInputs] = useState(initialFormInputsValues);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [allAffidavitRequests, setAllAffidavitRequests] = useState([]);
    const [isLoadingAllData, setIsLoadingAllData] = useState(false);
    const searchInputRef = useRef(null); // Create a ref for the input field

    const searchBoxStyles = {
        container: {
          display: "flex",
          alignItems: "center",
          border: "1px solid #0A722F",
          borderRadius: "10px",
          overflow: "hidden",
                 
            
        },
        input: {
          flex: 1,
          border: "none",
          outline: "none",
          padding: "10px 15px",
          fontSize: "14px",
          color: "#333",
          "::placeholder": {
            color: "#B0B0B0",
          },
        },
        button: {
          backgroundColor: "#0A722F",
          height: "100%",
          color: "#fff",
          padding: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "15%",
          cursor: "pointer",
        },
      };
      
    const handleSignatureClick = (documentUrl, id) => {
        navigate(`/signature?pdfUrl=${encodeURIComponent(documentUrl)}&id=${encodeURIComponent(id)}`);
    };

    useEffect(() => {
        if (id) {
            setSearchText(id);
            fetchaffidavitbyId(id);
            handleFiltering(id);
        }
    }, [id]);
    
    const fetchaffidavitbyId = async (id) => {
        setIsLoadingAllData(true);
        try {
            const affidavitResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/affidavit?documentId=${id}`,
                "GET"
            );
            return affidavitResponse;
           
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setIsLoadingAllData(false);
        }
    };
    const handleFiltering = async (searchValue) => {
        const affidavitResponse = await fetchaffidavitbyId(searchValue);
        let filteredRequests = affidavitResponse;
        if (filteredRequests.content === undefined || filteredRequests?.content?.length === 0 || searchValue === "") {
            setFilteredAffidavitRequests(null);
            setFormInputs(initialFormInputsValues);
            setPdfThumbnail(null);
            filteredRequests = []; 
        } else {
            const affidavit = filteredRequests;
            setFormInputs({
                documentId: affidavit.content.documentId || "",
                lawyerName: affidavit.content.user ? `${affidavit.content.user.lastName} ${affidavit.content.user.firstName}` : "",
                courtName: affidavit.content.court?.courtName || "",
                courtDivisionName: affidavit.content.courtDivision?.courtDivisionName || "",
                appointmentDate: affidavit.content.appointmentDate? format(new Date(affidavit.content.appointmentDate), "do MMMM yyyy").replace(/(\d+)(st|nd|rd|th)/, '$1$2') : "",
                status: affidavit.content.status || "",
                deponentName: affidavit.content.deponentName || "",
                isTranslatorRequired: affidavit.content.isTranslatorRequired || ""
            });
            loadPdfThumbnail(affidavit?.content?.signedDocumentUrl ? affidavit?.content?.signedDocumentUrl : affidavit?.content?.documentUrl);
           
        } 
        setFilteredAffidavitRequests(filteredRequests);
    };
    
    // const handleSearchTextChange = (event) => {
    //     setSearchText(event.target.value);
    //    };
       const onclicksearch =() => {
        setFilteredAffidavitRequests(null);
        const searchValue = searchInputRef.current.value; 
        handleFiltering(searchValue);
       }

    const handleDownload = (documentUrl) => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };

    //load image thumbnail
    const loadPdfThumbnail = async (url) => {
        try {
            setPdfLoading(true);
            const decodedUrl = decodeURIComponent(url);
            const loadingTask = pdfjsLib.getDocument(decodedUrl);
            const pdf = await loadingTask.promise;
            const page = await pdf.getPage(1);
            const scale = 0.5;
            const viewport = page.getViewport({ scale });

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            const renderContext = {
                canvasContext: context,
                viewport: viewport,
            };
            await page.render(renderContext).promise;
            setPdfThumbnail(canvas.toDataURL("image/png"));
        } catch (error) {
            console.error("Error loading PDF: ", error);
        } finally {
            setPdfLoading(false);
        }
    };

    return (
        <div className="affidavit-search-wrapper">
        <div style={{  backgroundColor: "#FFF",height:"100%"}}>
            <div className="page-title">
                <p>Search For Affidavit</p>
            </div>
            </div>
            <div className="search-and-filter-container1 space-between-sections1">
                <div className="search-container1">
                <div className="search-wrapper1">
                <div className="search" style={searchBoxStyles.container}>
                        <input
                            type="text"
                            placeholder="Search by Document Id"
                            className="search-input"
                            style={searchBoxStyles.input}
                            ref={searchInputRef} // Attach the ref to the input field
                            defaultValue={searchText} // Use defaultValue instead of value
                        />
                        <IconButton
                            iconProps={{ iconName: "Search" }}
                            style={searchBoxStyles.button}
                            onClick={() => onclicksearch()}
                        />
                </div>
                        {/* <span className="note">
                e.g. NJC/EAFF/1234/123
            </span> */} 
                </div> 
                              
                </div>
                <p className="note">
                            e.g. NJC/EAFF/1234/123
                 </p>  
            </div>
            {isLoadingAllData ? (
                <div className="loader"></div>
            ) :  (!filteredAffidavitRequests?.content) && (
                <div className="emptytext">
                        <img src={searchfile} alt='no file image'/>
                        <h5>Nothing to see yet!</h5>
                         <p>Please enter a Document ID to get started.</p></div>
            )
        }
            <div className='content-wrapper' style={{display: filteredAffidavitRequests?.content ? '' : 'none' }}>
                    <Card sx={{ p: { xs: 1.5, md: 3 }, display: "flex", alignItems: "stretch" , borderRadius:"0px", gap: '20px',flexDirection: { xs: "column", md: "row" }}}>
                        <Box flex={1} display="flex" flexDirection="column" gap={2}>
                            <form style={{ height: '100%', display: 'block' }}>
                                <div className='form-wrapper'>
                                    <div className='nr-form-container'>
                                        <div className='nr-form-inputs-container searchform'>
                                            <div className='sections'>
                                                <div className='input-container'>
                                                    <label htmlFor="documentId">Document ID:</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.documentId}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='input-container'>
                                                    <label htmlFor="lawyername">Lawyer’s Name:</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.lawyerName}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='input-container'>
                                                    <label htmlFor="courtId">Court Name:</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.courtName}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='input-container'>
                                                    <label htmlFor="courtDivisionId">Court Division:</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.courtDivisionName}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='input-container'>
                                                    <label htmlFor="appointmentDate">Appointment Date:</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.appointmentDate}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='input-container'>
                                                    <label htmlFor="deponentName">Deponent's Name:</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.deponentName}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='input-container'>
                                                    <label htmlFor="isTranslatorRequired">Translator Required? :</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.isTranslatorRequired}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='input-container'>
                                                    <label htmlFor="Status">Status :</label>
                                                    <input
                                                        type="text"
                                                        value={formInputs.status}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Box>
                        {/* <Divider orientation="vertical" flexItem sx={{ borderColor: "green", marginX: 2 }} /> */}
                        <Box flex={1} display="flex" justifyContent="center" alignItems="center" flexDirection="column" gap={1} style={{borderRadius: "2px",backgroundColor: "#F6F6F6"}} sx={{ mt: { xs: 4, md: 0 }}}
>
                            <img src={pdfThumbnail || defaultImage} alt="Document Preview" style={{ width: "100%",  objectFit: "contain" , height: 250, backgroundColor: "rgb(246, 246, 246)",marginTop:"30px" }} />
                            {pdfLoading && <p>Loading preview...</p>}
                            {pdfThumbnail && (
                                <Typography variant="body2" sx={{ cursor: "pointer", margin: 0, padding: "5px", border: "1px solid black", borderRadius: "6px",marginBottom:"10px"}} onClick={() => handleDownload(filteredAffidavitRequests?.content?.signedDocumentUrl ? filteredAffidavitRequests?.content?.signedDocumentUrl : filteredAffidavitRequests?.content?.documentUrl)} >
                                    Click to expand
                                    <img src={expandicon} style={{padding:"0px 0px 0px 20px"}}></img>
                                </Typography>
                            )}
                        </Box>
                    </Card>
                    {/* Modal for Document Preview */}
                    {isModalOpen && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                            <button className="close-button" onClick={closeModal}>
                                    <img src={clearicon} alt="Close" />
                                    Close
                                </button>
                                <iframe
                                    src={
                                        filteredAffidavitRequests?.content?.signedDocumentUrl
                                            ? `/pdfjs/viewer.html?file=${encodeURIComponent(filteredAffidavitRequests.content.signedDocumentUrl)}`
                                            : filteredAffidavitRequests?.content?.documentUrl
                                            ? `/pdfjs/viewer.html?file=${encodeURIComponent(filteredAffidavitRequests.content.documentUrl)}`
                                            : ''
                                        }style={{ width: '100%', marginTop: '10px', height: '100%', flex: 1, boxSizing: 'border-box', overflow: 'auto',WebkitOverflowScrolling: 'touch' }}
                                    title="Document Preview"
                                />
                            </div>
                        </div>
                    )}
                    <div className='nr-form-button-wrapper'>
                        <button
                            className="submit-btn"
                            onClick={() => handleSignatureClick(filteredAffidavitRequests?.content?.documentUrl, filteredAffidavitRequests?.content?.documentId)}
                            style={{ marginBottom: '20px', marginTop: '20px' }}
                            title={filteredAffidavitRequests?.content?.status !== "Pending" ? 'You cannot action this because it has been completed' : ''}
                            disabled={filteredAffidavitRequests?.content?.status === "Approved"}>
                            Add Signature
                        </button>
                    </div>
            </div>
        </div>
    );
};

export default SearchRequest;